module.exports = __webpack_public_path__ + "Flag-740.7a7a2547a69f5a2da65897df1951cb48.svg";